export default __webpack_public_path__ + "static/media/twi.74cc4eff.svg";